/**
 * Tool Sorcerer enhancements.
 * Gives product images a description from the product name when no alt text
 * has been set in the Shopify admin, so screen readers and image search still
 * get something meaningful. Setting alt text on the images themselves is
 * still the better fix; this only fills gaps.
 */
(() => {
  const IMAGE_SELECTOR = [
    '.card__media img',
    '.card .media > img',
    '.cart-item__image',
    '.product-banner-carousel__image',
  ].join(',');

  const NAME_SELECTOR = '.card__heading, .cart-item__name';

  /** @param {HTMLImageElement} image */
  const nameFor = (image) => {
    const container = image.closest('.card-wrapper, .card, .cart-item');
    const heading = container?.querySelector(NAME_SELECTOR);
    return heading?.textContent.replace(/\s+/g, ' ').trim() ?? '';
  };

  const fillMissingAlt = () => {
    for (const image of document.querySelectorAll(IMAGE_SELECTOR)) {
      if (image.getAttribute('alt')) continue;
      if (image.getAttribute('role') === 'presentation' || image.getAttribute('aria-hidden') === 'true') continue;
      const name = nameFor(image);
      if (name) image.setAttribute('alt', name);
    }
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      fillMissingAlt();
    }, 250);
  };

  fillMissingAlt();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();